import AppRoutes from "./app.routes";

function App() {
  return (
    <AppRoutes />
  );
}

export default App;
